import React, { useState, useEffect } from 'react';
import './ContactForm.css';

const ContactForm = ({ 
  onClose, 
  showPartnershipType = false, 
  defaultPartnershipType = '',
  formTitle = "Get in Touch"
}) => {
  const [formData, setFormData] = useState({
    partnershipType: defaultPartnershipType,
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [formStatus, setFormStatus] = useState('');
  const [showPopup, setShowPopup] = useState(false);

  // Auto-close success popup after 2 seconds
  useEffect(() => {
    if (showPopup && formStatus === 'success') {
      const timer = setTimeout(() => {
        handlePopupClose();
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [showPopup, formStatus]);

  const handleInputChange = (e) => {
    // Don't allow partnership type changes if it's pre-selected
    if (e.target.name === 'partnershipType' && defaultPartnershipType) {
      return;
    }
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const getPartnershipLabel = (type) => {
    const labels = {
      'traveler': 'Traveler/Ambassador',
      'lodging': 'Lodging Partner',
      'investment': 'Investment Inquiry',
      'other': 'Other Partnership'
    };
    return labels[type] || 'General Inquiry';
  };

  const handlePopupClose = () => {
    window.location.href = '/';
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setFormStatus('sending');

    try {
      // Use your existing REACT_APP_BACKEND_URL
      const baseURL = process.env.REACT_APP_BACKEND_URL;
      
      const endpoint = showPartnershipType ? '/api/partnership-inquiry' : '/api/contact';
      
      const response = await fetch(`${baseURL}${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          subject: showPartnershipType 
            ? `BackPass Partnership Inquiry - ${getPartnershipLabel(formData.partnershipType)}`
            : 'BackPass Contact Form Submission'
        }),
      });

      if (response.ok) {
        setFormStatus('success');
        setShowPopup(true);
      } else {
        setFormStatus('error');
        setShowPopup(true);
      }
    } catch (error) {
      setFormStatus('error');
      setShowPopup(true);
    }
  };

  return (
    <>
      <div className="contact-form-component">
        <h2 className="form-title-caveat">{formTitle}</h2>
        <form className="contact-form" onSubmit={handleFormSubmit}>
          {showPartnershipType && (
            <select
              name="partnershipType"
              value={formData.partnershipType}
              onChange={handleInputChange}
              disabled={!!defaultPartnershipType}
              required
            >
              <option value="">Select Partnership Type</option>
              <option value="traveler">Traveler/Ambassador</option>
              <option value="lodging">Lodging Partner</option>
              <option value="investment">Investment Inquiry</option>
              <option value="other">Other Partnership</option>
            </select>
          )}

          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleInputChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />

          {showPartnershipType && (
            <input
              type="tel"
              name="phone"
              placeholder="Your Phone Number"
              value={formData.phone}
              onChange={handleInputChange}
              required
            />
          )}

          <textarea
            name="message"
            placeholder={showPartnershipType ? "Tell us about your interest in BackPass" : "Your Message"}
            rows="5"
            value={formData.message}
            onChange={handleInputChange}
            required
          />

          <button type="submit" disabled={formStatus === 'sending'}>
            {formStatus === 'sending' ? 'Sending...' : (showPartnershipType ? 'Send Inquiry' : 'Send Message')}
          </button>
        </form>
      </div>

      {/* Popup Modal */}
      {showPopup && (
        <div className="popup-overlay" onClick={formStatus === 'success' ? handlePopupClose : undefined}>
          <div className={`popup-content ${formStatus === 'success' ? 'success-popup' : ''}`} onClick={(e) => e.stopPropagation()}>
            {formStatus === 'success' ? (
              <h3>We will be in touch!</h3>
            ) : (
              <>
                <h3>There was an error sending your inquiry.</h3>
                <p>Please contact matthew@backpass.co directly so he can fix this issue. You will also be moved to the front of the queue.</p>
                <button onClick={handlePopupClose}>OK</button>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ContactForm;